import { motion } from 'framer-motion';

const platforms = [
  { name: 'Amazon Prime', logo: 'prime' },
  { name: 'Apple TV', logo: 'apple' },
  { name: 'Tubi', logo: 'tubi' },
  { name: 'Fandango', logo: 'fandango' },
  { name: 'Plex', logo: 'plex' },
  { name: 'JustWatch', logo: 'justwatch' },
];

export const PlatformLogos = ({ className = '' }) => {
  return (
    <div className={`flex flex-wrap items-center justify-center gap-8 md:gap-12 ${className}`}>
      {platforms.map((platform, index) => (
        <motion.div
          key={platform.name}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: index * 0.1 }}
          data-testid={`platform-${platform.logo}`}
          className="font-display text-xl md:text-2xl text-white/40 hover:text-white/70 transition-colors cursor-default uppercase tracking-wider"
        >
          {platform.name}
        </motion.div>
      ))}
    </div>
  );
};
